module.exports = __webpack_public_path__ + "img/icon_map_62_off_111.e9ebcb26.png";